
import { UPDATE_ROLE_ID } from '../actions/actionTypes';
//@ts-ignore
import objectPath from 'object-path';

export default function reducer(state = {}, action: any) {
    let newState;
    switch (action.type) {
        case UPDATE_ROLE_ID:
            newState = Object.assign({}, state);
            objectPath.set(newState, action.payload.stateLocation, action.payload.roleId);
            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./modules/role-id-window-post/reducers/index.ts